<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="商品：" prop="goodsId">
            <el-select style="width: 420px;" v-model="ruleForm.goodsId" placeholder="请选择商品">
              <el-option v-for="(item,index) in goodsList" :key="index" :label="item.goodsName" :value="item.goodsId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名称：" prop="goodsName">
            <el-input style="width: 424px;" v-model="ruleForm.goodsName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="商品副标题：" prop="subTitle">
            <el-input style="width: 424px;" placeholder="请输入商品副标题" v-model="ruleForm.subTitle"></el-input>
          </el-form-item>
          <el-form-item label="图片：" prop="thumb">
             <el-upload
               :action="baseUrl+'/system/common/upload/uploadFile'"
               list-type="picture-card"
               :headers="{'Authorization': token}"
               :multiple="false"
               :limit="1"
               :file-list="fileList"
               :on-remove="delImgBtn.bind(null,{'type':1})"
               :on-success="uploadImgBtn">
               <i class="el-icon-plus"></i>
               <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多一张，若需要更换图片，请先删除原图片</div>
             </el-upload>
           </el-form-item>
           <el-form-item label="商品相册：" prop="secKillGoodsPictureList">
             <el-upload
               :action="baseUrl+'/system/common/upload/uploadFile'"
               list-type="picture-card"
               :headers="{'Authorization': token}"
               :limit="5"
               :file-list="secKillGoodsPictureListTwo"
               :on-remove="delImgBtn.bind(null,{'type':2})"
               :on-success="uploadTwoBtn">
               <i class="el-icon-plus"></i>
               <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多9张，若需要更换图片，请先删除原图片</div>
             </el-upload>
           </el-form-item>
          <el-form-item v-if="ruleForm.secKillGoodsSpecList.length > 0" label="规格：" prop="secKillGoodsSpecList">
            <el-table
              :data="ruleForm.secKillGoodsSpecList"
              border
              style="width: 100%">
              <el-table-column
                prop="specName"
                label="规格">
              </el-table-column>
              <el-table-column
                prop="thumb"
                label="图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 32px;"
                    :src="scope.row.thumb"
                    :preview-src-list="[scope.row.thumb]"
                    fit="contain"></el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="apiSpecPrice"
                label="售价">
              </el-table-column>
              <el-table-column
                prop="secKillPrice"
                label="秒杀价"
                width="120">
                <template slot-scope="scope">
                  <el-input style="width: 90px;" v-model="scope.row.secKillPrice" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="apiStockNum"
                label="库存">
              </el-table-column>
              <el-table-column
                prop="stockNum"
                label="限量"
                width="120">
                <template slot-scope="scope">
                  <el-input style="width: 90px;" v-model="scope.row.stockNum" placeholder="请输入"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="apiWeight"
                label="重量(kg)">
              </el-table-column>
              <el-table-column
                prop="volume"
                label="体积(m³)">
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="购买限制：" prop="buyLimit">
            <el-input style="width: 424px;" v-model="ruleForm.buyLimit" placeholder="请输入购买限制（个），默认0，为不限制"></el-input>
            <div class="mt-warm-txt"><span>该商品活动期间内，用户可购买的最大数量，例如设置为2，表示本次活动有效期内，每个用户可最多购买2件</span></div>
          </el-form-item>
          <el-form-item label="配送方式：" prop="goodsId">
            <el-checkbox v-model="expressDelivery">快递配送</el-checkbox>
            <el-checkbox v-model="pickupDelivery">自提</el-checkbox>
            <el-checkbox v-model="enableDelivery">同城配送</el-checkbox>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#13ce66"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryAllEnableGoodsList, saveSecKillGoods, updateSecKillGoods, fetchSecKillGoodsDetailById } from '@/api/seckill'
export default {
  name: 'SeckillAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      goodsList: [],
      pickupDelivery:false,
      expressDelivery:false,
      enableDelivery:false,
      fileList: [],
      /* 商品相册 */
      secKillGoodsPictureListTwo: [],
      secKillGoodsPictureList:[],
      ruleForm: {
        goodsId: '',
        goodsName:'',
        subTitle:'',
        thumb:'',
        secKillGoodsPictureList:[],
        secKillGoodsSpecList:[],
        buyLimit:'',
        sort: '',
        status: false
      },
      rules: {
        goodsId: [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        thumb: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        secKillGoodsPictureList: [
          { required: true, message: '请上传相册', trigger: 'blur' }
        ],
        secKillGoodsSpecList: [
          { required: true, message: '请完成规格', trigger: 'blur' }
        ]
      },
      isOne:1
    }
  },
  watch: {
    'ruleForm.goodsId': {
      handler(newVal, oldVal) {
        var that = this;
        if(that.dataId == '' || (that.dataId != '' && that.isOne == 2)){
          that.goodsList.forEach(function(item){
            if(newVal == item.goodsId){
              that.ruleForm.secKillGoodsSpecList = item.secKillGoodsSpecList;
            }
          });
        }
        that.isOne = 2;
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    this.goodsFun();
    if (this.$route.query.dataId === undefined || this.$route.query.dataId === 'undefined') {
      this.dataId = ''
    } else {
      let that = this
      fetchSecKillGoodsDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.goodsId = data.goodsId
          that.ruleForm.goodsName = data.goodsName
          that.ruleForm.subTitle = data.subTitle
          that.ruleForm.secKillGoodsSpecList = data.secKillGoodsSpecPageVoList;
          that.ruleForm.buyLimit = data.buyLimit
          that.ruleForm.sort = data.sort
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          // 配送
          if(data.expressDelivery == 1){
            that.expressDelivery = true;
          }else{
            that.expressDelivery = false;
          }
          // 自提
          if(data.pickupDelivery == 1){
            that.pickupDelivery = true;
          }else{
            that.pickupDelivery = false;
          }
          // 同城配送
          if(data.enableDelivery == 1){
            that.enableDelivery = true;
          }else{
            that.enableDelivery = false;
          }
          // 商品主图
          that.fileList.push({url: data.thumb});
          that.ruleForm.thumb = data.thumb
          // 商品相册
          data.secKillGoodsPictureList.forEach(function(item){
            that.secKillGoodsPictureListTwo.push({url: item});
            that.secKillGoodsPictureList.push(item);
          });
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 商品列表数据
    goodsFun(){
      let that = this
      queryAllEnableGoodsList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.goodsList = data;
        }
      })
    },
    // 商品主图上传
    uploadImgBtn (file) {
      this.ruleForm.thumb = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(obj,file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 商品主图
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.ruleForm.thumb = thumb;
          break;
        case 2:
          // 商品相册
          var secKillGoodsPictureList = [];
          fileList.forEach(function(item){
            secKillGoodsPictureList.push(item.url);
          });
          that.secKillGoodsPictureList = secKillGoodsPictureList;
          break;
      }
    },
    /* 商品相册上传 */
    uploadTwoBtn (file) {
      this.secKillGoodsPictureList.push(file.data.fileUrl)
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let goodsId = that.ruleForm.goodsId
      let goodsName = that.ruleForm.goodsName
      let subTitle = that.ruleForm.subTitle
      let thumb = that.ruleForm.thumb
      let secKillGoodsPictureList = that.secKillGoodsPictureList
      let secKillGoodsSpecSaveDtoList = that.ruleForm.secKillGoodsSpecList
      let buyLimit = that.ruleForm.buyLimit
      let status = that.ruleForm.status ? 1 : 0
      let pickupDelivery = that.pickupDelivery ? 1 : 0
      let expressDelivery = that.expressDelivery ? 1 : 0
      let enableDelivery = that.enableDelivery == true ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      if (goodsId === '') {
        this.$message.error('请选择商品')
        return false
      }
      if (goodsName === '') {
        this.$message.error('请输入商品名称')
        return false
      }
      let passData = {
        goodsId: goodsId, goodsName: goodsName,subTitle:subTitle,thumb:thumb,secKillGoodsPictureList:secKillGoodsPictureList, secKillGoodsSpecSaveDtoList: secKillGoodsSpecSaveDtoList, buyLimit: buyLimit, status: status, sort: sort, pickupDelivery: pickupDelivery, expressDelivery: expressDelivery,enableDelivery:enableDelivery
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateSecKillGoods(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveSecKillGoods(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/seckill/GoodsAdd.vue